module.exports = __webpack_public_path__ + "static/assets/04e830c035b8a5b18064e65bc8603e67.png";